export default function CcpMosRegionColumns() {
	return [
		{
			name: "code",
			title: "Код",
			width: "275px",
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: false,
			filter: false,
			editable: false,
		},
		{
			name: "name",
			title: "Наименование",
			colSpan: "2",
			cellHorAlign: "left",
			headHorAlign: "left",
			sort: false,
			filter: false,
			editable: false,
		},
		{
			name: "measure_unit",
			title: "Ед. изм",
			width: "70px",
			cellHorAlign: "center",
			headHorAlign: "left",
			sort: false,
			filter: false,
			editable: false,
		},
		{
			name: "opt_cost",
			title: "Отпускная цена, руб.",
			width: "185px",
			cellHorAlign: "center",
			headHorAlign: "center",
			sort: false,
			filter: false,
			editable: false,
		},
		{
			name: "cost",
			title: "Сметная цена, руб.",
			width: "185px",
			cellHorAlign: "center",
			headHorAlign: "center",
			sort: false,
			filter: false,
			editable: false,
		},
	];
}
